import request from '@/utils/request'

// 训练营详情页
export function seven_index(data){
	return request({
    url: '/api/Seven/index',
    method: 'POST',
    data: data || {}
  })
}

// 入学资料获取
export function getInfo(data){
	return request({
    url: '/api/Seven/getInfo',
    method: 'POST',
    data: data || {}
  })
}

// 入学资料提交
export function setInfo(data){
	return request({
    url: '/api/Seven/setInfo',
    method: 'POST',
    data: data || {}
  })
}
// 详情页（参团）
export function joinMission(data){
  return request({
    url: '/api/Seven/joinMission',
    method: 'POST',
    data: data || {}
  })
}
// 拼团详情页
export function setMission(data){
  return request({
    url: '/api/Seven/setMission',
    method: 'POST',
    data: data || {}
  })
}

// 获取班主任微信
export function getQrcode(data){
  return request({
    url: '/api/Seven/getQrcode',
    method: 'POST',
    data: data || {}
  })
}

// 购买成功页面
export function buySucess(data){
  return request({
    url: '/api/Seven/buySucess',
    method: 'POST',
    data: data || {}
  })
}

// 邀请进度页面
export function inviteProgress(data){
  return request({
    url: '/api/Seven/inviteProgress',
    method: 'POST',
    data: data || {}
  })
}

// 订单详情
export function orderDetail(data){
  return request({
    url: '/api/Seven/orderDetail',
    method: 'POST',
    data: data || {}
  })
}

// 海报分享
export function getPosters(data){
  return request({
    url: '/api/Seven/getPosters',
    method: 'POST',
    data: data || {}
  })
}

// 邀请语分享
export function getInviteWord(data){
  return request({
    url: '/api/Seven/getInviteWord',
    method: 'POST',
    data: data || {}
  })
}

// 邀请详情
export function inviteList(data){
  return request({
    url: '/api/Seven/inviteList',
    method: 'POST',
    data: data || {}
  })
}

// 我的下级
export function myDownline(data){
  return request({
    url: '/api/Seven/myDownline',
    method: 'POST',
    data: data || {}
  })
}

// 推广员邀请
export function invitePromoter(data){
  return request({
    url: '/api/Seven/invitePromoter',
    method: 'POST',
    data: data || {}
  })
}

// 推广员邀请 -- 接受邀请
export function acceptInvite(data){
  return request({
    url: '/api/Seven/acceptInvite',
    method: 'POST',
    data: data || {}
  })
}

// 招募
export function recruit(data){
  return request({
    url: '/api/Seven/recruit',
    method: 'POST',
    data: data || {}
  })
}
// 招募 -- 提交
export function apply(data){
  return request({
    url: '/api/Seven/apply',
    method: 'POST',
    data: data || {}
  })
}

// 进度详情   分页
export function progressList(data){
  return request({
    url: '/api/Seven/progressList',
    method: 'POST',
    data: data || {}
  })
}
// 7天职业定位特训营
export function activity(data){
  return request({
    url: '/api/seven/activity',
    method: 'POST',
    data: data || {}
  })
}

// 7天训练营分班管理获取数据
export function getFormSubmit(data){
  return request({
    url: '/admin/seven/getFormSubmit',
    method: 'POST',
    data: data || {}
  })
}
// 7天训练营分班管理提交数据
export function updateFormSubmit(data){
  return request({
    url: '/admin/seven/updateFormSubmit',
    method: 'POST',
    data: data || {}
  })
}